<template>
  <div class="block-sh">
    <div class="block-sh__content">
      <div class="block-sh__left">
        <div class="block-sh__letter letter letter-red" data-aos="fade-up">Ш.</div>
        <div class="block-sh__title" data-aos="fade-up">
          Шпион
        </div>
        <div class="block-sh__text" data-aos="fade-up">Как многие артисты, композиторы, поэты и певцы того времени, Вертинский в свободное от работы время успевал быть ещё и шпионом (конечно же, с точки зрения властей). Заработать такую репутацию ему оказалось несложно: в период, когда он гастролировал по Бессарабии (в то время территория Румынии), Вертинский по какой-то причине отказался участвовать<br>в бенефисе некой кишинёвской актрисы, являвшейся любовницей местного генерала. </div>
      </div>
      <div class="block-sh__right">
        <div class="block-sh__element" data-aos="fade-up"></div>
        <div class="block-sh__image" data-aos="fade-up"><img src="../assets/img/sh-1.jpg" alt=""></div>
        <div class="block-sh__result" data-aos="fade-up">
          <i class="block-sh__result-i block-sh__result-i--1"></i>
          <i class="block-sh__result-i block-sh__result-i--2"></i>
          <p>
          Результат не заставил себя ждать. <br>
          <span>Вертинский был обвинён в шпионаже</span><br>в пользу СССР, а также «разжигание <br>антирумынских настроений» и был <br>депортирован в Бухарест.</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'BlockF'
}
</script>

<style lang="sass">
  .block-sh
    color: #000
    padding-bottom: vw(20px)
    padding-bottom: vw(132px)
    &__element
      width: vw(208px)
      height: vw(366px)
      background-image: url(../assets/img/key.svg)
      background-size: contain
      position: absolute
      margin-left: vw(-94px)
      margin-top: vw(9px)
      z-index: 300
    &__result
      width: vw(362px)
      height: vw(170px)
      background-color: #fff
      display: flex
      align-items: center
      justify-content: center
      border: 1px solid #000
      margin-top: vw(-18px)
      margin-left: vw(131px)
      position: relative
      z-index: 100
      &-i
        width: vw(12px)
        height: vw(12px)
        background-color: #000
        border-radius: vw(20px)
        position: absolute
        top: vw(4px)
        left: vw(4px)
        &--2
          top: auto
          left: auto
          bottom: vw(4px)
          right: vw(4px)
          transform: rotate(100deg)
        &:before
          content: ''
          display: block
          width: vw(17px)
          height: vw(1.5px)
          background-color: #fff
          top: vw(6px)
          left: vw(-1.7px)
          position: absolute
          transform: rotate(-133deg)
      span
        color: #740D0C
      p
        text-align: center
        font-size: vw(16px)
        font-family: 'Tautz'
        line-height: vw(20px)
    &__content
      display: flex
    &__left
      width: vw(500px)
      margin-left: vw(89px)
    &__right
      margin-left: vw(111px)
    &__image
      width: vw(560px)
      margin-left: vw(11px)
      margin-top: vw(93px)
      position: relative
      &:before
        content: ''
        display: block
        width: vw(839px)
        height: vw(620px)
        background-image: url(../assets/img/sh-1-bg.png)
        background-size: contain
        position: absolute
        top: vw(-138px)
        left: vw(0px)
      img
        width: 100%
    &__text
      width: vw(454px)
      margin-left: vw(111px)
      text-align: right
      font-family: 'Tautz'
      font-size: vw(16px)
      margin-top: vw(39px)
      letter-spacing: vw(-0.05px)
      line-height: vw(20px)
    &__title
      font-size: vw(72px)
      font-family: 'ZnikomitNo25'
      text-align: left
      margin-left: vw(245px)
      margin-top: vw(18px)
    &__letter
      margin-left: vw(245px)
      margin-top: vw(97px)
      padding-left: vw(26px)
      padding-top: vw(17px)
      color: #fff

</style>
